// import { createContext, useState, ReactNode, useContext } from 'react'

// export type SettingsContextValue = {
// 	isDashboardDrawerOpened: boolean,
// 	setIsDashboardDrawerOpened: () => void,
// }

// export const SettingsContext = createContext<SettingsContextValue>({
// 	isDashboardDrawerOpened: true,
// 	setIsDashboardDrawerOpened: () => null,
// })

// export const SettingsProvider = ({ children }: { children: ReactNode }) => {
// 	const [isDashboardDrawerOpened, saveIsDashboardDrawerOpened] = useState<boolean>(window.innerWidth >= 1200)

// 	const setIsDashboardDrawerOpened = () => saveIsDashboardDrawerOpened(!isDashboardDrawerOpened);

// 	return <SettingsContext.Provider value={{ isDashboardDrawerOpened, setIsDashboardDrawerOpened }}>{children}</SettingsContext.Provider>
// }

// export const SettingsConsumer = SettingsContext.Consumer

// export const useSettings = (): SettingsContextValue => useContext(SettingsContext)

import { createContext, useState, ReactNode, useContext } from 'react';

export type SettingsContextValue = {
  isDashboardDrawerOpened: boolean;
  setIsDashboardDrawerOpened: () => void;
  isActivityDialogOpened: boolean;
  setIsActivityDialogOpened: () => void;
};

export const SettingsContext = createContext<SettingsContextValue>({
  isDashboardDrawerOpened: true,
  setIsDashboardDrawerOpened: () => null,
  isActivityDialogOpened: false,
  setIsActivityDialogOpened: () => null,
});

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
  // State for managing the dashboard drawer
  const [isDashboardDrawerOpened, saveIsDashboardDrawerOpened] = useState<boolean>(window.innerWidth >= 1200);
  
  // State for managing the activity dialog
  const [isActivityDialogOpened, saveIsActivityDialogOpened] = useState<boolean>(false);

  // Toggle functions for both states
  const setIsDashboardDrawerOpened = () => saveIsDashboardDrawerOpened(!isDashboardDrawerOpened);
  const setIsActivityDialogOpened = () => saveIsActivityDialogOpened(!isActivityDialogOpened);

  return (
    <SettingsContext.Provider
      value={{
        isDashboardDrawerOpened,
        setIsDashboardDrawerOpened,
        isActivityDialogOpened,
        setIsActivityDialogOpened,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

// Optional: SettingsConsumer for class components
export const SettingsConsumer = SettingsContext.Consumer;

// Custom hook for using settings context
export const useSettings = (): SettingsContextValue => useContext(SettingsContext);
